import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { InputForm } from '@/components/ui/inputForm';

const InputTextForm = ({
  name,
  placeholder,
  className,
  minLength = 3,
  maxLength = 100,
  label,
  isRequired = false,
  isDisabled = false,
  customValidation,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation('translation', { keyPrefix: 'inputs' });
  const defaultValidationRule = {
    minLength: {
      value: minLength,
      message: t('minLength'),
    },
    maxLength: {
      value: maxLength,
      message: t('maxLength'),
    },
  };

  const validationRules = customValidation || defaultValidationRule;

  if (isRequired) {
    validationRules.required = t('required');
  }

  return (
    <div className={`${className}`}>
      <FormField
        name={name}
        control={control}
        rules={validationRules}
        disabled={isDisabled}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{label}</FormLabel>
            <FormControl>
              <InputForm
                disabled={isDisabled}
                placeholder={placeholder}
                {...field}
                error={errors[name]}
                style={{ visibility: 'visible', position: 'static', zIndex: 'auto' }}
              />
            </FormControl>
            {errors[name] && (
              <div className='d-flex align-items-center error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </FormItem>
        )}
      />
    </div>
  );
};

export default InputTextForm;
